<template>
	<button class="primary-btn py-3 px-1 md:px-4 inline-block rounded-lg text-center  font-medium bg-primary text-secondary hover:text-white hover:bg-secondary transition-colors">
		<slot></slot>
	</button>
</template>

<script>
export default {}
</script>